import { render, staticRenderFns } from "./modalCheckInfo.vue?vue&type=template&id=85029f46"
import script from "./modalCheckInfo.vue?vue&type=script&lang=js"
export * from "./modalCheckInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports